import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { UPLOAD_ACTIVITY_FILE_BEGIN, logError, sendAlert } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function uploadActivityFile(action$, state$) {
    return action$.pipe(ofType(UPLOAD_ACTIVITY_FILE_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.uploadAsset(action.activity, action.file, action.onProgress)).pipe(switchMap(function(result) {
            var actions = [
                sendAlert({
                    message: "Begin uploading file ...",
                    messageType: "info"
                })
            ];
            return actions;
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "upload_activity_file"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "upload_activity_file"
        }));
    }));
}
